/* eslint-disable src-restricted/error-page-prefer-throw -- defines a supported error page */
import type { FC } from 'react';

import { Text } from '@opendoor/bricks-next';

import { useAuthWithClientSideFallback } from 'platform/auth-fe';
import { TextButton } from 'platform/bricks-next';

import { GenericErrorPage } from 'shared/routes/errors/GenericErrorPage';

/** Page to show when user is trying to access their offer with the wrong account. */
export const WrongAccountPage: FC = () => {
  const { logout } = useAuthWithClientSideFallback();
  return (
    <GenericErrorPage
      reason="wrong-account"
      causedBy="user-error"
      headerContent="This offer may be linked to a different email address"
    >
      <Text tag="p" typography="$bodyMedium" textAlign="center">
        <TextButton
          data-testid="sign-out"
          display="inline"
          analyticsName="account-redirect"
          onClick={() => void logout()}
          label="Sign out"
          size="small"
          variant="primary"
        />{' '}
        and try another email address to view it.
      </Text>
    </GenericErrorPage>
  );
};
